<template lang="pug" src="./newsletter.pug"></template>

<style lang="sass">
    @import ../../../common/styles/settings
    @import ../../../common/styles/animations
    @import newsletter
</style>
<script>
    import { localstorage } from '../../../mixins/localstorage'
    import { useEmitter } from '@nguyenshort/vue3-mitt'
    import Modal from '../Modal.vue'
    import { computed, onUpdated, onMounted, ref, reactive, nextTick, watch } from 'vue'
    import { useForm } from 'vee-validate';
    import * as yup from 'yup';
    import Cookies from "js-cookie";

    export default {
      components: {
            Modal
        },
        mixins: [localstorage],
        props: {
            email: {
                type: String,
                default: ''
            }
        },
        setup(props){
            const { checkLS } = localstorage.methods;
            const emitter = useEmitter()
            const isPosted =  ref(false);
            const isLoading =  ref(false);
            const displayPopin =  ref(false);
            const isGtmValue =  ref(false);
            const optin =  ref('J’autorise la société Antargaz Finagaz à utiliser les données me concernant afin de recevoir de la part de la société Antargaz Finagaz des actualités et offres promotionnelles concernant ses produits et services dans le domaine de l\'énergie.');
            const form =  reactive({email: '',optin: true,lists: [],listsmarche: [],client: undefined});
            const stored =  ref({step: 1, total: 1, status: 'in'});
            const formEl =  ref(null);
            const show =  ref(false);
            const isLaunched =  ref(false);
            const { values, errors, defineField, validate } = useForm({
              validationSchema: yup.object({
                emailField: yup.string().email('L\'email est invalide').required('L\'email est requis'),
              }),
            });
            const [emailField, emailFieldAttrs] = defineField('emailField', {
              validateOnModelUpdate: false,
            });
            const isFormFilled = computed(() => {
                if (isGtmUri()) {
                    return form.lists.length > 0;
                } else {
                    return form.lists.length > 0 && emailField !== '' && form.listsmarche.length > 0;
                }
            });
            const  isClientAndListFilled = computed(() => {
              isLaunched.value = true
                setTimeout(() => {
                    if ( !show.value ){
                        isLaunched.value = false
                    }
                }, 2000)
                return form.lists.length > 0 && emailField !== '' && form.listsmarche.length > 0;
            });
            const requiredInputChecked = computed(() => {
                if(isClientAndListFilled.value && !isLaunched.value) {
                    show.value = true
                }
            });
            const isGTM = computed(() => {
                return isGtmUri()
            });


            function switchPage(){
              show.value = !show.value
            };
            function isGtmUri() {
              const uriPath = window.location.href;

              if (uriPath.includes("user_type")) {
                  isGtmValue.value = true;
                  return isGtmValue.value;
              } else {
                  return false;
              }
          }

            function togglePopin (state) {
                displayPopin.value = state
                // If mail has been registered, never shows it again
                if(isPosted.value){
                  killPopin()
                }
            };
            function checkIfIsUnique () {
                let input = getInput(`input[name='email']`)
                if (input && checkIfClassExists(input, 'error')) {
                  form.email = input.value
                    //errors.add('email', 'Vous êtes déjà inscrit à nos newsletter.', 'email');
                }
            };
            function checkIfClassExists (input, className) {
                return input.classList ? input.classList.contains(className) : new RegExp('(^| )' + className + '( |$)', 'gi').test(input.className);
            };
            function getInput (selector) {
                return formEl.value.querySelector(selector)
            };
            function updateInput (selector, type, value) {
                let input = getInput(selector)
                if (input && type === 'boolean') {
                    input.value = value
                }
                if (input && type === 'object') {
                    input.checked = value
                }
                if (input && type === 'string') {
                    input.value = value
                }
            };

            const submit = (() => {
              if(isGtmValue.value){
                    const inputs = [...formEl.value.querySelectorAll('input')]

                    inputs.forEach(async (i) => {
                      let name = i.name.split('[')[0] || null

                      function getQueryParam(name) {
                          const match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
                          return match ? decodeURIComponent(match[1]) : null;
                      }

                      const plateformUrl = getQueryParam('at_platform');
                      console.log(plateformUrl);
                        
                        async function fetchSessionValue(type) {
                            const redirectUrls = {
                              Prof: {
                                googlePopin: "/pro/du-fioul-au-gaz",
                                generic: "/citerne-de-gaz/generique-professionnels"
                              },
                              Particulier: {
                                googlePopin: "/du-fioul-au-gaz",
                                generic: "/citerne-de-gaz/generique-particuliers"
                              }
                            };
                                
                            const targetUrl = getQueryParam('at_platform') === "google-popin-fioul"
                            ? redirectUrls[type].googlePopin
                            : redirectUrls[type].generic;

                            setTimeout(() => {
                                 window.location.href = targetUrl;
                                  }, 500)
                            // try {
                            //     const response = await fetch('/antargaz_custom/get-session-value');
                            //     if (!response.ok) {
                            //         throw new Error('Erreur lors de la récupération de la valeur de session.');
                            //     }
                            //     const data = await response.json();
                            //     let url_redirect_campaign = data.value;
                                
                            //     const targetUrl = url_redirect_campaign === "/?at_platform=google-popin-fioul"
                            //     ? redirectUrls[type].googlePopin
                            //     : redirectUrls[type].generic;


                            //     setTimeout(() => {
                            //     window.location.href = targetUrl;
                            //      }, 500)

                            // } catch (error) {
                            //     console.error(error);
                            // }
                        }



                        async function redirectToUrl(type) {
                          await fetchSessionValue(type);
                        }
                      if (name && Object.prototype.hasOwnProperty.call(form, name)) {
                            let value = form[name]
                            if (name === 'lists' && (value === 'Prof' || value === 'Particulier')) {
                              redirectToUrl(value);
                            }
                        }
                    })
                }
                isFormFilled.value && validate().then((result) => {
                    if (result.valid) {
                      form.email = emailField
                        isLoading.value = true
                        var eventDetail = '';

                        // Fill out Drupal form inputs

                        let inputs = [...formEl.value.querySelectorAll('input')]
                        inputs.forEach(i => {

                            let name = i.name.split('[')[0] || null


                            if (name && Object.prototype.hasOwnProperty.call(form, name)) {

                                let value = form[name]
                                if(name === 'lists'){
                                  switch (value[0]) {
                                    case 'Prof':
                                      eventDetail = 'Professionnel';
                                      break;
                                    case 'Particulier':
                                      eventDetail = 'Particulier';
                                      break;
                                  }
                                }

                                if(name === 'client'){
                                  switch (value[0]) {
                                    case 'oui':
                                      form.client = true;
                                      break;
                                    case 'non':
                                      form.client = false;
                                      break;
                                  }
                                }

                                switch (i.type) {
                                    case 'checkbox' :
                                        if (value === i.value)
                                            i.setAttribute('checked', 'checked')
                                        else
                                            i.removeAttribute('checked')
                                        break
                                    default :
                                        i.value = value
                                        break
                                }

                            }
                        })

                        if (checkLS()) {
                            let popin = JSON.parse(localStorage.getItem('newsletterPopin')) || stored
                            popin.status = 'posted'
                            localStorage.setItem('newsletterPopin', JSON.stringify(popin))
                        }

                        // Datalayer
                      window.dataLayer.push({
                          'event': 'newsletter_subscription',
                          'event_detail': eventDetail,
                          'event_location': 'popin',
                        });

                        formEl.value.submit()
                        killPopin();

                    } else {
                        isLoading.value = false
                    }
                });
            });
            function killPopin() {
                if (checkLS()) {
                    let popin = JSON.parse(localStorage.getItem('newsletterPopin')) || stored.value
                    popin.status = 'out'
                    localStorage.setItem('newsletterPopin', JSON.stringify(popin))
                }
            }

            const handleNewsletter = (email) => {
                emailField.value = email
              };

            onUpdated(() => {
                form.email = props.email !== '' ?props.email : form.email
            });
            onMounted(async () => {
              await nextTick()
              isGtmUri()
              emitter.on('dispatchNewsletter', handleNewsletter);
              formEl.value = document.querySelector('.webform-submission-newsletter-form')
              if (formEl.value) {
                  isPosted.value = formEl.value.querySelector('.webform-confirmation') !== null
                  checkIfIsUnique()
              }
            })

            return { optin, submit, updateInput, isGTM, switchPage, togglePopin, isFormFilled, requiredInputChecked, validate, displayPopin, form, values, errors, show, emailField, isLoading }
            }
      }

</script>
